import React from "react";
import _ from "lodash";
import JoditEditor from "jodit-react";
import {
  Box,
  Button,
  FormControl,
  Icon,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import { CloseIcon, CopyIcon } from "../assets/images";

const FormikJoditEditor = ({
  field: { ...fields },
  ...props
}): React.ReactNode => {
  const defaultConfig = React.useMemo(
    () => ({
      readonly: false,
      editorCssClass: true,
      toolbarAdaptive: false, // Toolbar adaptive show buttons in more buttons
      showCharsCounter: false,
      showWordsCounter: false,
      defaultMode: 1,
      height: 525,
      spellcheck: true, // For check spelling
      askBeforePasteHTML: false, // Ask before paste HTML
      askBeforePasteFromWord: false, // Ask before paste from Word/Excel
      showXPathInStatusbar: false,
      defaultActionOnPaste: "insert_only_text",
      disablePlugins:
        "about, source, class-span, search,file,fullsize,add-new-line,video,image,table,speech-recognize,preview,print,aiAssistant,symbols, indent, outdent", // remove button about, source, class-span
    }),
    []
  );
  const { className, config = defaultConfig, ...rest } = props;

  const firstRef = React.useRef(true);

  React.useEffect(() => {
    if (fields?.value) firstRef.current = false;
  }, [fields?.value]);

  const copyText = (text: string) => {
    if (text) {
      navigator.clipboard.writeText(text);
    }
  };

  return (
    <Modal
      open={props.open}
      onClose={(event, reason) => {
        if (reason === "backdropClick") return; // Prevent closing on backdrop click
        props.handleClose();
      }}
      disableEnforceFocus
    >
      <Box className="modal-box">
        <div className="modal-head">
          <Typography variant="h4" className="modal-title">
            AI Assistant
          </Typography>
          <IconButton
            className="icon-btn btn-close"
            onClick={props.handleClose}
          >
            <img src={CloseIcon} alt="Icon" />
          </IconButton>
        </div>
        <div className="modal-body" style={{ paddingTop: 16 }}>
          <div className="ck-outer">
            <FormControl fullWidth className={`reset-css ${className}`}>
              <JoditEditor
                {...fields}
                {...rest}
                value={props.value}
                config={config}
              />
            </FormControl>
          </div>
        </div>
        <div className="modal-footer">
          <Button
            variant="contained"
            color="primary"
            onClick={() => copyText(fields?.value)}
          >
            <Icon>
              <img src={CopyIcon} alt="Icon" />
            </Icon>
            Copy Text
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default FormikJoditEditor;
